import type { CorvidSDKFactory } from '@wix/editor-elements-types/corvid';
import { composeSDKFactories } from '../../../utils/velo/composeSdks';
import { elementSdkFactory } from '../../../utils/velo/elementSdk';

export const SOCIAL_PLAYER_YOUTUBE_SDK_TYPE = '$w.YoutubePlayer';

export const createSocialPlayerYoutubeSdk: CorvidSDKFactory = api => {
  const { props, setProps } = api;
  return {
    get type() {
      return SOCIAL_PLAYER_YOUTUBE_SDK_TYPE;
    },
    get src() {
      return props.url || '';
    },
    set src(value: string) {
      setProps({ url: value });
    },
    get description() {
      return props.description || '';
    },
    set description(value: string) {
      setProps({ description: value });
    },
    get autoPlay() {
      return props.autoPlay ?? false;
    },
    set autoPlay(value: boolean) {
      setProps({ autoPlay: value });
    },
    get loop() {
      return props.loop ?? false;
    },
    set loop(value: boolean) {
      setProps({ loop: value });
    },
    get isMuted() {
      return props.mute ?? false;
    },
    set isMuted(value: boolean) {
      setProps({ mute: value });
    },
    get startTime() {
      return props.startTime ?? 0;
    },
    set startTime(value: number) {
      setProps({ startTime: value });
    },
    get endTime() {
      return props.endTime ?? 0;
    },
    set endTime(value: number) {
      setProps({ endTime: value });
    },
    get showControls() {
      return props.enabledControls ?? false;
    },
    set showControls(value: boolean) {
      setProps({ enabledControls: value });
    },
    get showCaptions() {
      return props.enabledCaptions ?? false;
    },
    set showCaptions(value: boolean) {
      setProps({ enabledCaptions: value });
    },
  };
};

export const SocialPlayerYoutubeSdk = composeSDKFactories([
  elementSdkFactory(SOCIAL_PLAYER_YOUTUBE_SDK_TYPE),
  createSocialPlayerYoutubeSdk,
]);

export default SocialPlayerYoutubeSdk;
